<template>
	<div class="w-full max-w-[1000px] px-6 mx-auto">
		<div class="mt-10 mb-6">
			<p class="mb-2 text-lg font-medium">Bezit de klant een eigen woning?</p>
			<AppRadioCardSelect
				v-model="selectedOption"
				:options="hasOwnedPropertyOptions"
			/>
		</div>

		<template v-if="hasOwnedProperty === true">
			<div class="pb-32">
				<CurrentObjectDetails v-if="primaryObject" v-model="primaryObject" />
			</div>
		</template>

		<template v-else-if="hasOwnedProperty === false">
			<AppCard title="Geen eigen woning">
				<p class="text-gray-600">
					De klant bezit geen eigen woning. Er hoeft geen huidig object ingevuld
					te worden.
				</p>
			</AppCard>
		</template>

		<div class="mt-6 pb-32">
			<KlantgegevensVerkoopCard />
		</div>
	</div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { useCurrentObjects } from "@/composables/useCurrentObjects";
import CurrentObjectDetails from "@/components/inventarisation/current-objects/CurrentObjectDetails.vue";
import KlantgegevensVerkoopCard from "@/components/inventarisation/KlantgegevensVerkoopCard.vue";

const { hasOwnedProperty, primaryObject } = useCurrentObjects();

const selectedOption = computed({
	get: () => {
		if (hasOwnedProperty.value === true) return "yes";
		if (hasOwnedProperty.value === false) return "no";
		return undefined;
	},
	set: (value: string | undefined) => {
		if (value === "yes") hasOwnedProperty.value = true;
		else if (value === "no") hasOwnedProperty.value = false;
		else hasOwnedProperty.value = undefined;
	},
});

const hasOwnedPropertyOptions = [
	{
		value: "yes",
		label: "Ja, eigen woning",
		icon: "home",
	},
	{
		value: "no",
		label: "Nee",
		icon: "apartment",
	},
];
</script>
